import Chocolat from "chocolat";

export default {
    init() {
        Chocolat(document.querySelectorAll('.chocolat-parent .chocolat-image'), {
            imageSize: 'contain',
            loop: true,
            className: 'aircraft-modal',
        })
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/aircraftPortfolio.js